import './App.css';
import Footer from './Component/Footer';
import Contact_Component from './Component/Contact_Component';
import Main_Brand_slider from './Component/Main_Brand_slider';
import Review_Component from './Component/Review_Component';
import Total_Count from './Component/Total_Count';
import Navbar from './Component/Navbar';
import Seconde_Component from './Component/Seconde_Component';
import Roadmap_Component from './Component/Roadmap_Component';
import Third_Component from './Component/Third_Component';
import Navbar_mobile from './Component/Navbar_mobile';
import Main_Navbar from './Component/Main_Navbar';
import Home_page from './Component/Home_page';
import About_us from './Page/About_us';
import Campus_Ambassador from './Component/Campus_Ambassador';
import Our_program from './Page/Our_program';
import Testmonial_page from './Component/Testmonial_page';
import BDA_job from './Component/BDA_job';
import Advance_program_page from './Page/Advance_program_page';
import Program_details_page from './Page/Program_details_page';
import ML_page from './Component/Machine_learning/ML_page';
import WD_page from './Component/Wed_Development/WD_page'
import DS_page from './Component/Data_Science/DS_page';
import CS_page from './Component/Cyber Security/CS_page';
import AI_page from './Component/Artificial Intelligence/AI_page';
import CC_page from './Component/Cloud Computing/CC_page';
import AAD_page from './Component/Android App Development/AAD_page';
import RO_page from './Component/Robotics/RO_page';
import AC_page from './Component/AutoCAD/AC_page';
import HR_page from './Component/Human Resource/HR_page';
import FA_page from './Component/Finance/FA_page';
import BA_page from './Component/Business Analytics/BA_page';
import DM_page from './Component/Digital Marketing/DM_page';
import Java_page from './Component/Java/Java_page';
import PY_page from './Component/Python/PY_page'
import DMM_page from './Component/Digital Marketing & Marketing/DMM_page';
import FSW_page from './Component/Full Stack Web/FSW_page';
import MS_page from './Component/MS Course/MS_page';
import CCD_page from './Component/C, C++ with DSA/CCD_page';
import Main_Home_page from './Page/Main_Home_page';
import Register_page from './Page/Ragister_page';
import Fade from 'react-reveal/Fade';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link
} from "react-router-dom";
import Login_page from './Page/Login_page';
import Data_page from './Page/Data_page';
import CA_form_page from './Component/CA_form_page';
import Mern_stack from './Page/Mern_stack';
import Contact_page from './Page/Contact_page';
import Student_Register_form from './Page/Student_Register_form';
import Project_page from './Page/Bootcamps_page';
import Terms_page from './Page/Terms_page';
import Not_Found from './Page/Not_Found';
import Terms_and_Conditions from './Page/Terms_and_Conditions';
import ScrollToTop from './Component/ScrollToTop';
import Mobile_program from './Component/Mobile_program';
import Mobile_career from './Component/Mobile_career';
import VLSI_page from './Component/VLSI/VLSI_page'
import IOT_page from './Component/IOT/IOT_page'
import Loader from './Page/Loader';
import ES_page from './Component/Embedded System/ES_page';
import Bootcamps_page from './Page/Bootcamps_page';
import Careere_popup from './Component/Careere_popup';
function App() {
  return (

    <>
    {/* <Loader/> */}
    <Router>
    <div className="App">
    <ScrollToTop/>
    <Main_Navbar/>
      <Routes>
      <Route path="/" element={<Main_Home_page/>}/>
      <Route path="/About-us" element={<About_us/>}/>
      <Route path='/Bootcamps' element={<Bootcamps_page/>}/>
      <Route path='/Privacy-Policy' element={<Terms_page/>}/>
      <Route path='/T&C' element={<Terms_and_Conditions/>}/>
      <Route path="/Contact" element={<Contact_page/>}/>
      <Route path="/Traineeship-program" element={<Our_program/>}/>
      <Route path="/Advance-program" element={<Advance_program_page/>}/>
      <Route path="/CA" element={<Campus_Ambassador/>}/>
      <Route path="/BDA" element={<BDA_job/>}/>
      <Route path="/contact" element={<Contact_Component/>}/>
      <Route path="/AI" element={<AI_page/>}/>
      <Route path="/ML" element={<ML_page/>}/>
      <Route path="/WD" element={<WD_page/>}/>
      <Route path="/DS" element={<DS_page/>}/>
      <Route path="/AAD" element={<AAD_page/>}/>
      <Route path="/RO" element={<RO_page/>}/>
      <Route path="/CS" element={<CS_page/>}/>
      <Route path="/CC" element={<CC_page/>}/>
      <Route path="/HR" element={<HR_page/>}/>
      <Route path="/FA" element={<FA_page/>}/>
      <Route path="/BA" element={<BA_page/> }/>
      <Route path="/AC" element={<AC_page/>}/>
      <Route path="/DM" element={<DM_page/> }/>
      <Route path="/java" element={<Java_page/>}/>
      <Route path="/PY" element={<PY_page/>}/>
      <Route path="/DMM" element={<DMM_page/>}/>
      <Route path="/FSW" element={<FSW_page/>}/>
      <Route path='/MS' element={<MS_page/>}/>
      <Route path="/CCD" element={<CCD_page/>}/>
      <Route path="/VLSI" element={<VLSI_page/>}/>
      <Route path="/IOT" element={<IOT_page/>}/>
      <Route path="/ES" element={<ES_page/>}/>
      <Route path="/Cpopup" element={<Careere_popup/>}/>
      <Route path='/CAF' element={<CA_form_page/>}/> 
      <Route path='/Student_register' element={<Student_Register_form/>}/> 
      <Route path='/Program' element={<Mobile_program/>}/> 
      <Route path='/Careers' element={<Mobile_career/>}/> 
      <Route path='*' element={<Not_Found/>}/> 
      </Routes>
      <Footer/>
    </div>

    
    </Router>
    </>

    
    
   
  );
}

export default App;
